@if (data?.title) {
<div mat-dialog-title class="markdown-title">
  <h4><strong [innerHTML]="data.title"></strong></h4>
</div>
}
<mat-dialog-content aria-label="Reward Popup Dialog Content">
  <div class="modal-body">
    @if (data?.image) {
    <div class="text-center mb-4">
      <img class="reward-popup-image" [src]="data.image" alt="Rewards" />
    </div>
    }
    @if (data?.content) {
    <div class="fs-17 mb-2" [innerHTML]="data.content"></div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" aria-label="Reward Popup Dialog Actions"
  class="d-flex flex-column flex-sm-row align-items-stretch gap-2">
  <button class="btn btn-primary order-1 order-sm-2" (click)="cancel()">Close</button>
</mat-dialog-actions>
